'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEVICE_QUERY = 'device:query';
var DEVICE_QUERY_IS_DESKTOP = 'device:query:is-desktop';
var DEVICE_QUERY_IS_TABLET = 'device:query:is-tablet';
var DEVICE_QUERY_IS_MOBILE = 'device:query:is-mobile';
var DEVICE_QUERY_IS_IOS = 'device:query:is-ios';
var DEVICE_QUERY_IS_IPAD = 'device:query:is-ipad';

exports.DEVICE_QUERY = DEVICE_QUERY;
exports.DEVICE_QUERY_IS_DESKTOP = DEVICE_QUERY_IS_DESKTOP;
exports.DEVICE_QUERY_IS_IOS = DEVICE_QUERY_IS_IOS;
exports.DEVICE_QUERY_IS_IPAD = DEVICE_QUERY_IS_IPAD;
exports.DEVICE_QUERY_IS_MOBILE = DEVICE_QUERY_IS_MOBILE;
exports.DEVICE_QUERY_IS_TABLET = DEVICE_QUERY_IS_TABLET;
